import { BaseRequest } from '@trukt/types/BaseRequest';
import { AxiosInstance } from 'axios';

type FuelRateBody = {
  price: string;
  date: string;
};

export type CoupaGetFuelRatesRequest = {
  month: number;
  year: number;
};

export type CoupaGetFuelRatesResponseItem = {
  date: string;
  price: string;
};
export type CoupaGetFuelRatesResponse = CoupaGetFuelRatesResponseItem[];

export type CoupaPostFuelRateRequest = BaseRequest<void, FuelRateBody>;
export type CoupaPostFuelRateResponse = void;

export class CoupaService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getFuelRates(request: CoupaGetFuelRatesRequest) {
    return this.instance.get<CoupaGetFuelRatesResponse>('/coupa/fuel-rate', { params: request });
  }

  postFuelRate({ body }: CoupaPostFuelRateRequest) {
    return this.instance.put<CoupaPostFuelRateResponse>('/coupa/fuel-rate', body);
  }
}
